import Vue from "vue";
import App from "./App";
import Axios from "axios";
import store from './services/store'
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import { routes } from "./routes/index";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/default.css";
import VueCookies from "vue-cookies";
import VueScrollTo from 'vue-scrollto'

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);
Vue.use(VueCookies);



Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

export const consultor = {
  is: null
}

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App)
});
